if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getStringingOptions() {
        const container = document.querySelector('.stringing-options');
        if (!container) return null;

        const activeTab = container.querySelector('.stringing-tab.active');
        const type = activeTab ? activeTab.dataset.type : 'strung';

        const sectionId = container.dataset.sectionId || container.dataset.section || 'main';
        const comments = container.querySelector('.stringing-comments');
        const commentsValue = comments ? comments.value.trim() : '';

        function getSelectedStringData(selectEl) {
          if (!selectEl || !selectEl.value) return null;
          const option = selectEl.options[selectEl.selectedIndex];
          return {
            title: selectEl.value,
            variantId: option ? option.dataset.variantId : null,
            price: option ? option.dataset.price : null,
          };
        }

        let selectedString = null;
        let selectedMainString = null;
        let selectedCrossString = null;

        if (type === 'strung') {
          const stringSelect = container.querySelector(`#strung-string-select-${sectionId}`);
          selectedString = getSelectedStringData(stringSelect);
        } else if (type === 'hybrid') {
          const mainStringSelect = container.querySelector(`#hybrid-main-string-select-${sectionId}`);
          const crossStringSelect = container.querySelector(`#hybrid-cross-string-select-${sectionId}`);
          selectedMainString = getSelectedStringData(mainStringSelect);
          selectedCrossString = getSelectedStringData(crossStringSelect);
        }

        return {
          type,
          comments: commentsValue,
          selectedString,
          selectedMainString,
          selectedCrossString,
        };
      }

      buildStringProperties(stringing, stringRole) {
        const props = {};
        props['String Type'] = stringing.type === 'strung' ? 'מתוזר' : 'היברידי';
        props['Role'] = stringRole;

        if (stringing.type === 'strung' && stringing.selectedString) {
          props['Selected String'] = stringing.selectedString.title;
          props['Tension'] = stringing.selectedTension || '';
        } else if (stringing.type === 'hybrid') {
          if (stringRole === 'main' && stringing.selectedMainString) {
            props['Main String'] = stringing.selectedMainString.title;
            props['Main Tension'] = stringing.selectedMainTension || '';
          } else if (stringRole === 'cross' && stringing.selectedCrossString) {
            props['Cross String'] = stringing.selectedCrossString.title;
            props['Cross Tension'] = stringing.selectedCrossTension || '';
          }
        }

        if (stringing.comments) {
          props['Comments'] = stringing.comments;
        }

        return props;
      }

      addToCart(variantId, quantity, properties, sections) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);

        for (const [key, value] of Object.entries(properties || {})) {
          formData.append(`properties[${key}]`, value);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        return fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
      }

      getTensionValue(container, sectionId, type, field) {
        const select = container.querySelector(`#${type}-${field}-select-${sectionId}`);
        return select ? select.value : '';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const sections = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : [];

        const stringing = this.getStringingOptions();
        let lastResponse = null;
        let response = null;

        try {
          const mainVariantId = this.variantIdInput.value;
          const mainQuantity = this.form.querySelector('input[name="quantity"]')?.value || '1';

          if (stringing && stringing.type === 'strung' && stringing.selectedString) {
            const mainResponse = await this.addToCart(mainVariantId, mainQuantity, {}, sections);
            lastResponse = mainResponse;

            if (mainResponse.status) {
              this.handleErrorMessage(mainResponse.description || mainResponse.message);
              this.showSoldOut();
              return;
            }

            const tension = this.getTensionValue(
              document.querySelector('.stringing-options'),
              document.querySelector('.stringing-options').dataset.sectionId || 'main',
              'strung',
              'tension'
            );

            const stringProperties = {
              'String Type': 'מתוזר',
              'Selected String': stringing.selectedString.title,
              'Tension': tension,
            };
            if (stringing.comments) stringProperties['Comments'] = stringing.comments;

            const stringResponse = await this.addToCart(
              stringing.selectedString.variantId,
              '1',
              stringProperties,
              sections
            );
            lastResponse = stringResponse;

            if (stringResponse.status) {
              this.handleErrorMessage(stringResponse.description || stringResponse.message);
              this.showSoldOut();
              return;
            }
          } else if (stringing && stringing.type === 'hybrid') {
            const mainResponse = await this.addToCart(mainVariantId, mainQuantity, {}, sections);
            lastResponse = mainResponse;

            if (mainResponse.status) {
              this.handleErrorMessage(mainResponse.description || mainResponse.message);
              this.showSoldOut();
              return;
            }

            if (stringing.selectedMainString) {
              const mainTension = this.getTensionValue(
                document.querySelector('.stringing-options'),
                document.querySelector('.stringing-options').dataset.sectionId || 'main',
                'hybrid-main',
                'tension'
              );

              const mainStringProperties = {
                'String Type': 'היברידי',
                'Role': 'main',
                'Main String': stringing.selectedMainString.title,
                'Main Tension': mainTension,
              };
              if (stringing.comments) mainStringProperties['Comments'] = stringing.comments;

              const mainStringResponse = await this.addToCart(
                stringing.selectedMainString.variantId,
                '1',
                mainStringProperties,
                sections
              );
              lastResponse = mainStringResponse;

              if (mainStringResponse.status) {
                this.handleErrorMessage(mainStringResponse.description || mainStringResponse.message);
                this.showSoldOut();
                return;
              }
            }

            if (stringing.selectedCrossString) {
              const crossTension = this.getTensionValue(
                document.querySelector('.stringing-options'),
                document.querySelector('.stringing-options').dataset.sectionId || 'main',
                'hybrid-cross',
                'tension'
              );

              const crossStringProperties = {
                'String Type': 'היברידי',
                'Role': 'cross',
                'Cross String': stringing.selectedCrossString.title,
                'Cross Tension': crossTension,
              };
              if (stringing.comments) crossStringProperties['Comments'] = stringing.comments;

              const crossStringResponse = await this.addToCart(
                stringing.selectedCrossString.variantId,
                '1',
                crossStringProperties,
                sections
              );
              lastResponse = crossStringResponse;

              if (crossStringResponse.status) {
                this.handleErrorMessage(crossStringResponse.description || crossStringResponse.message);
                this.showSoldOut();
                return;
              }
            }
          } else {
            const formData = new FormData(this.form);
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            response = await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());
            lastResponse = response;

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.showSoldOut();
              return;
            }
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainVariantId,
              cartData: lastResponse,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(lastResponse);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(lastResponse);
            });
          }
        } catch (e) {
          console.error(e);
          this.handleErrorMessage(window.cartStrings?.error || 'Error adding to cart');
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          CartPerformance.measureFromEvent("add:user-action", evt);
        }
      }

      showSoldOut() {
        this.error = true;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (soldOutMessage) soldOutMessage.classList.remove('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
